import { render } from "./OpportunityProductsCard.vue?vue&type=template&id=083026e4&scoped=true"
import script from "./OpportunityProductsCard.vue?vue&type=script&lang=js"
export * from "./OpportunityProductsCard.vue?vue&type=script&lang=js"

import "./OpportunityProductsCard.vue?vue&type=style&index=0&id=083026e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083026e4"]])

export default __exports__